export default {
  value: { keyboard: 'numeric', style: 'inline5' },
  currency: {
    type: 'select', defaultValue: 'EUR', dataSource: ['EUR', 'USD'], style: 'inline5',
  },
  type: { style: 'inline5' },
  title: { style: 'inline5' },
  caption: { style: 'inline5' },
};
